import React from 'react';

const AboutHeroSection: React.FC = () => {
  return (
    <section 
      className="relative py-32 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(30, 64, 175, 0.8), rgba(30, 64, 175, 0.6)), url('https://public.readdy.ai/ai/img_res/d24f69c93f47813e48a1eda66dc1d085.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
            About <span className="text-orange-500">Professional Office Group</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-4xl mx-auto leading-relaxed">
            Your trusted partner for premium office furniture solutions across South Carolina. 
            We combine exceptional quality, competitive pricing, and unmatched service to transform workspaces.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutHeroSection;